<template>
    <v-dialog v-model="visible" persistent max-width="900px" scrollable>
        <v-card :loading="loading">
            <v-card-title>
                <span class="headline">Automation & API Settings</span>
            </v-card-title>
            <v-card-text>
              <p>
                Setup automatic compliance processes based on application events like new cases and API interactions. 
              </p>

              <v-row class="pa-4">
                <v-col cols="1">
                  <v-switch class="" v-model="editAccount.accountSettings.screenOnCreate"/>
                </v-col>
                <v-col>
                  <v-row class="subtitle-1 black--text">
                    <v-col>
                      Screen Cases on Creaction
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="8">
                      Screen new Cases immedietly after creation. Screening results, including any open Case Reports, will be avaialble 
                      via the new Cases ID. 
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row class="pa-4">
                <v-col cols="1">
                  <v-switch class="" v-model="editAccount.accountSettings.createOnScreen"/>
                </v-col>
                <v-col>
                  <v-row class="subtitle-1 black--text">
                    <v-col>
                      Create New Cases on Screening
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="8">
                      When enabled, a new Case will be created whenever a screening takes place. For example, when 
                      screening a name from the Veriscan home screen, or when a request is submitted to the Screening API.
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>




            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn color="blue darken-1" text @click="onCancel">{{ $t('label.cancel') }}</v-btn>
                <v-btn color="blue darken-1" @click="handleSubmit" dark :loading="loading">{{ $t('label.save')
                }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
  
<script>
import { mapActions } from "vuex";
export default {
    name: "EditComplianceAutoApi",
    data() {
        return {
            loading: false,
            editAccount: {
                ...this.account,
                accountSettings: this.account.accountSettings ? this.account.accountSettings : {}
            }
        };
    },
    props: {
        account: {},
        visible: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        account: {
            immediate: true,
            handler(val) {
                this.editAccount = {
                    ...val,
                    accountSettings: val.accountSettings ? val.accountSettings : {}
                }
            }
        }
    },
    methods: {
        ...mapActions([
            "updateAccount", "setGlobalAlert"
        ]),
        handleSubmit() {
            this.loading = true;
            this.updateAccount(this.editAccount)
                .then(() => {
                    this.setGlobalAlert({
                        alert: true,
                        color: "green",
                        alertMessage: "Compliance Settings Updated",
                    });
                    this.$emit("onCancelled");
                })
                .catch((err) => {
                    console.log("updateAccount.settings error", err)
                    this.setGlobalAlert({
                        alert: true,
                        color: "red",
                        alertMessage: this.$t("error.general.unhandled"),
                    });
                })
                .finally(() => {
                    this.loading = false;
                });

        },
        onCancel() {
            this.loading = false;
            this.$emit("onCancelled");
        }
    },
    created: function () {
    }
};
</script>